import { store } from '@wordpress/interactivity';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css'; // Importer les styles Leaflet
import 'leaflet.awesome-markers';
import 'leaflet.awesome-markers/dist/leaflet.awesome-markers.css'; // Styles Leaflet Awesome Markers
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle'; // Styles Swiper
import 'leaflet-gesture-handling';

import '@fortawesome/fontawesome-free/css/all.min.css'; // Styles Font Awesome
import { library, dom } from '@fortawesome/fontawesome-svg-core'; 
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';


// Ajouter les icônes dont tu as besoin à la bibliothèque Font Awesome
library.add(faLocationDot);

// Appliquer Font Awesome au DOM
dom.watch();

// Récupérer les données de l'état interactif
const { state } = store('gt_fse_map');

// Créer une variable pour stocker les coordonnées des marqueurs
let markerCoords = [];

// Initialiser la carte, mais sans définir la vue tout de suite
var map = L.map('map', {
    gestureHandling: true // Ajoute la gestion du zoom avec Ctrl ou deux doigts
});

// Ajouter les tuiles OpenStreetMap à la carte
L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
}).addTo(map);

// Ajouter des marqueurs pour chaque élément enfant et stocker leurs coordonnées
state.lesPOI.forEach((POI) => {
    // Créer un marqueur de couleur en fonction de la propriété pinColor du POI
    const markerIcon = L.AwesomeMarkers.icon({
        icon: 'fa-location-dot', // Icône que tu utilises avec FontAwesome (vérifie la bonne icône)
        markerColor: POI.pinColor || 'red', // Couleur du marqueur, rouge par défaut si non spécifiée
        prefix: 'fa', // Le préfixe est 'fa' pour FontAwesome
        iconColor: POI.pinColor || 'red' // Optionnelle, la couleur de l'icône à l'intérieur du marqueur
    });

    // Générer le contenu HTML pour la popup
    var bindPopupContent = `<div class="gt-fse-map__marker__content">`;
    if (POI.galleryImages.length > 0) {
        // Ajouter les classes swiper-container et swiper-wrapper pour Swiper
        bindPopupContent += `<div class="swiper-container gt-fse-map__marker__images">`;
        POI.galleryImages.forEach((img) => {
            bindPopupContent += `<div class="swiper-slide"><img src="${img.url}" alt="${img.alt}" /></div>`;
        });
        bindPopupContent += `</div>`;
    }
    if (POI.title) {
        bindPopupContent += `<div class="gt-fse-map__marker__element gt-fse-map__marker__titre">${POI.title}</div>`;
    }
    if (POI.address) {
        bindPopupContent += `<div class="gt-fse-map__marker__element gt-fse-map__marker__adresse"><label>Adresse : </label><span>${POI.address}</span></div>`;
    }
    if (POI.postalCode) {
        bindPopupContent += `<div class="gt-fse-map__marker__element gt-fse-map__marker__cp"><label>Code postal : </label><span>${POI.postalCode}</span></div>`;
    }
    if (POI.city) {
        bindPopupContent += `<div class="gt-fse-map__marker__element gt-fse-map__marker__ville"><label>Ville : </label><span>${POI.city}</span></div>`;
    }
    if (POI.email) {
        bindPopupContent += `<div class="gt-fse-map__marker__element gt-fse-map__email"><label>Email : </label><span>${POI.email}</span></div>`;
    }
    if (POI.phone) {
        bindPopupContent += `<div class="gt-fse-map__marker__element gt-fse-map__telephone"><label>Téléphone : </label><span>${POI.phone}</span></div>`;
    }
    if (POI.link != null) {
        bindPopupContent += POI.link;
    }
    bindPopupContent += `</div>`;

    // Ajouter le marqueur avec l'icône personnalisée et lier le popup si le contenu n'est pas vide
    const marker = L.marker([POI.latitude, POI.longitude], { icon: markerIcon }).addTo(map);
    if (bindPopupContent !== `<div class="gt-fse-map__marker__content"></div>`) {
        marker.bindPopup(bindPopupContent);
    }

    // Écouteur d'événement pour l'ouverture de la popup
    marker.on('popupopen', () => {
        // Initialiser Swiper uniquement lorsque la popup s'ouvre
        const swiper = new Swiper('.gt-fse-map__marker__images', {
            direction: 'horizontal',
            loop: true,
            createElements: true,
            slidesPerView: 1,
            autoplay: {
                delay: 3000,
            },
            navigation: true,
            scrollbar: true,
        });
    });

    // Ajouter les coordonnées des marqueurs dans le tableau
    markerCoords.push([POI.latitude, POI.longitude]);
});

// Vérifier si les coordonnées par défaut sont définies
if (state.cartes_attrs.latitude && state.cartes_attrs.longitude && !(state.cartes_attrs.latitude == 0 && state.cartes_attrs.longitude == 0)) {
    // Si les coordonnées sont définies, centrer la carte sur ces valeurs
    map.setView([state.cartes_attrs.latitude, state.cartes_attrs.longitude], state.cartes_attrs.zoom);
} else if (markerCoords.length > 0) {
    // Si pas de coordonnées par défaut, centrer la carte au milieu des marqueurs
    const bounds = L.latLngBounds(markerCoords);
    map.fitBounds(bounds); // Ajuste la vue sur les marqueurs

    // Vérifier si un zoom est défini dans state.cartes_attrs
    if (state.cartes_attrs.zoom) {
        map.setZoom(state.cartes_attrs.zoom); // Appliquer le zoom défini
    }
} else {
    // Si aucun marqueur n'est présent, centrer la carte sur des coordonnées en dur (par exemple, Biarritz)
    map.setView([43.469223, -1.5480856], 12); // Coordonnées de Biarritz avec un zoom de 12
}